import { Box, Text } from '@moosend/mooskin';
import * as React from 'react';

export const SidemenuItemStep: React.FC<any & { title: string; step: any; index: number }> = (props) => {
	const isDone = false;
	const isCurrent = props.active ?? props.currentItem === props.step;

	return (
		<Box d="flex" align="center" style={{ ...props.styles }} key={props.index} onClick={props.onClick} mt={props.index === 0 ? -20 : 0}>
			<Box d="flex" direction="column" justify="center" align="center">
				<Box w={2} h={20} bgColor={props.index === 0 ? 'transparent' : '#a3a3a3'} />
				<Box
					borderRadius={50}
					borderColor={isCurrent ? 'borderColors.secondary2' : isDone ? 'borderColors.secondary1' : 'transparent'}
					d="flex"
					justify="center"
					align="center"
					borderWidth={isCurrent || isDone ? 2 : 0}
					borderStyle="solid"
					w={35}
					h={35}
					p={2}
					my={isCurrent || isDone ? 0 : -2}
				>
					<Box
						borderRadius={50}
						bgColor={isCurrent ? 'backgroundColors.secondary2' : isDone ? '#38A169' : '#a3a3a3'}
						d="flex"
						justify="center"
						align="center"
						w="100%"
						h="100%"
					>
						<Text fontColor="fontColors.white" fontSize={16} fontWeight="bold">
							{props.index + 1}
						</Text>
					</Box>
				</Box>
				<Box w={2} h={20} bgColor={props.index === props.stepsInOrder.length - 1 ? 'transparent' : '#a3a3a3'} />
			</Box>
			<Box ml={10}>
				<Text>{props.children}</Text>
			</Box>
		</Box>
	);
};
